//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import React from "react";
import {
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Flex,
  Heading,
  Stack,
} from "@chakra-ui/react";
import ReactDOM from "react-dom";

const ModalDisplay: React.FC<any> = ({ ...rest }) => {
  return (
    <Modal
      isOpen={rest.isOpen}
      onClose={rest.onClose}
      size={rest.size}
      portalProps={{}}
      closeOnEsc={true}
      closeOnOverlayClick={true}
    >
      <ModalOverlay />
      <ModalContent overflow="auto" rounded="lg">
        {rest.header && <ModalHeader>{rest.header}</ModalHeader>}
        {rest.displayCloseButton ? <ModalCloseButton zIndex="modal" /> : null}
        <ModalBody px={8} py={10}>
          {rest.children}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

const NoModalDisplay: React.FC<any> = ({ ...rest }) => {
  return (
    <>
      <Flex flexDir={"column"}>
        {rest.header && <Heading>{rest.header}</Heading>}
        <Stack px={8} py={10}>
          {rest.children}
        </Stack>
      </Flex>
    </>
  );
};

export const EditContainer = ({
  size = "2xl",
  header = "",
  displayCloseButton = true,
  children,
  isOpen,
  onClose,
  useModal = true,
  childNode = undefined,
}) => {
  const Component = useModal ? ModalDisplay : NoModalDisplay;
  return (
    <Component
      {...{ isOpen, onClose, size, header, displayCloseButton, children }}
    />
  );
};
